<template>
  <div
    class="comments-sidebar"
    :class="{
      'd-flex flex-column justify-center': isCordLoading,
    }"
  >
    <div
      v-if="isCordLoading"
      class="loader-container d-flex justify-center"
    >
      <v-progress-circular
        indeterminate
        color="brandPrimary"
        size="40"
      />
    </div>
    <div v-else>
      <div class="threaded-comments-container">
        <cord-threaded-comments
          :location="JSON.stringify(threadLocation)"
          :thread-metadata="JSON.stringify(threadMetaData)"
          :thread-name="threadName"
          :thread-url="threadUrl || undefined"
          composer-position="top"
          display-resolved="sequentially"
          top-level-composer-expanded="false"
          scroll-direction="down"
        />
      </div>
    </div>

    <InlineCommentModal
      :thread-location="threadLocation"
      :thread-meta-data="threadMetaData"
      :thread-name="threadName"
    />
  </div>
</template>

<script>
import { useCommenting } from '@/stores/commenting/commenting';
import InlineCommentModal from './InlineCommentModal.vue';

export default {
  name: 'CommentsSidebar',
  components: { InlineCommentModal },

  props: {
    pageId: { type: [String, Number], default: '' },
    pageName: { type: String, default: 'editor-view' },
    pageTitle: { type: String, default: '' },
    threadUrl: { type: String, default: '' },
  },

  data() {
    return {
      threadCountsObserver: null,
    };
  },

  computed: {
    isCordLoading() {
      return useCommenting().isCordLoading;
    },
    threadLocation() {
      return { page: this.pageName, id: this.pageId ? String(this.pageId) : '' };
    },
    threadMetaData() {
      return { jobId: this.pageId ? String(this.pageId) : '' };
    },
    threadName() {
      return this.pageTitle;
    },
  },

  async mounted() {
    await useCommenting().loadCord(this.pageName === 'editor-view' ? { jobId: String(this.pageId) } : undefined);
    this.threadCountsObserver = useCommenting().cordSdk.thread.observeThreadCounts((threadCounts) => {
      useCommenting().setThreadCounts(threadCounts);
    }, { filter: { location: { value: this.threadLocation } } });
  },

  beforeUnmount() {
    if (this.threadCountsObserver) {
      useCommenting().cordSdk.thread.unobserveThreadCounts(this.threadCountsObserver);
    }
  },
};
</script>

<style scoped lang="less">
@import '@/less/cord';

.comments-sidebar {
  &:deep(.threaded-comments-container) {
    .cord-threaded-comments {
      border: none;
    }
  }

  height: 100%;
  min-height: 200px;

  .loader-container {
    min-width: 188px;
  }

  .cord-common-styles();
  .cord-message-styles();
  .cord-threaded-comments-styles();
}
</style>
